import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField, FormControlLabel, Switch } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { putApi } from 'views/services/api';
import { toast } from 'react-toastify';

const EditExchangeRate = ({ open, handleClose, data, onRefresh }) => {
  const hotel = JSON.parse(localStorage.getItem('hotelData')) || {};

  const validationSchema = Yup.object().shape({
    currency: Yup.string().required('Currency is required'),
    abbreviation: Yup.string().required('Abbreviation is required'),
    rate: Yup.number().positive('Rate must be positive').required('Rate is required')
  });

  const handleSubmit = async (values) => {
    try {
      const payload = {
        ...values,
        hotelId: hotel?.hotelId
      };
      const res = await putApi(`api/exchange/update/${data._id}`, payload);
      if (res.status === 200) {
        toast.success('Exchange rate updated successfully');
        handleClose();
        if (typeof onRefresh === 'function') {
          onRefresh(); // ✅ vuelve a cargar la lista
        }
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong while updating');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Exchange Rate</DialogTitle>
      <Formik
        initialValues={{
          currency: data.currency || '',
          abbreviation: data.abbreviation || '',
          rate: data.rate || '',
          isActive: data.isActive ?? true
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, setFieldValue }) => (
          <Form>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Currency"
                    name="currency"
                    fullWidth
                    value={values.currency}
                    onChange={handleChange}
                    error={touched.currency && Boolean(errors.currency)}
                    helperText={touched.currency && errors.currency}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Abbreviation"
                    name="abbreviation"
                    fullWidth
                    value={values.abbreviation}
                    onChange={handleChange}
                    error={touched.abbreviation && Boolean(errors.abbreviation)}
                    helperText={touched.abbreviation && errors.abbreviation}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Exchange Rate"
                    name="rate"
                    type="number"
                    fullWidth
                    value={values.rate}
                    onChange={handleChange}
                    error={touched.rate && Boolean(errors.rate)}
                    helperText={touched.rate && errors.rate}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Switch checked={values.isActive} onChange={() => setFieldValue('isActive', !values.isActive)} />}
                    label="Active"
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                Save Changes
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditExchangeRate;
